import { render } from "./PtSelect.vue?vue&type=template&id=b22146dc&ts=true"
import script from "./PtSelect.vue?vue&type=script&lang=ts"
export * from "./PtSelect.vue?vue&type=script&lang=ts"

import "./PtSelect.vue?vue&type=style&index=0&id=b22146dc&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__